import { lazyRouteComponent } from "@tanstack/react-router";
import { House } from "lucide-react";

import type { PageDef } from "@/app/registry";

/**
 * The signed-in home page, by role: an investor's (and admin's) market at a
 * glance with their analysts' calls, an RA's practice, or an RA client's
 * analyst. Employees don't get it (no `employees` flag): their home is the
 * sales console.
 */
export const pages: PageDef[] = [
  {
    path: "/app/home",
    title: "Home",
    component: lazyRouteComponent(() => import("./HomePage"), "HomePage"),
    // first item of the first section, so it heads the menu and the phone bar
    nav: { label: "Home", icon: House, group: "Markets", order: -10 },
  },
];
